<template>
    <b-container fluid class="detail-page">

        <b-row class="">
            <b-col cols="12">
                <div class="border-bottom mb-3 pb-3">
                    <h3>{{ modalTitle }}</h3>
                    <p class="fw-400 text-secondary mb-0">
                        Assessment 평가 및 서비스를 이용하는 기업 정보를 관리합니다.
                    </p>
                </div>
            </b-col>
        </b-row>

        <div class="d-flex justify-content-between align-items-center mb-3">
            <div>
                <b-button variant="outline-secondary" @click="goToList">
                    <fa icon="arrow-left" class="mr-2"></fa>
                    {{  $t('목록으로') }}
                </b-button>
            </div>
            <div class="action-btns">
                <template v-if="mode === 'detail'">
                    <b-button variant="outline-primary"
                              @click="changeMode('edit')"
                    >
                        {{ $t('수정')}}
                    </b-button>
                </template>
                <template v-else-if="mode === 'add'">
                    <b-button variant="outline-primary"
                              form="company-form"
                              type="submit"
                    >
                        {{ $t('저장')}}
                    </b-button>
                </template>
                <template v-else-if="mode === 'edit'">
                    <b-button variant="outline-danger">
                        {{ $t('삭제') }}
                    </b-button>
                    <b-button variant="outline-primary"
                              form="company-form"
                              type="submit"
                    >
                        {{ $t('저장') }}
                    </b-button>
                    <b-button variant="outline-secondary"
                              @click="changeMode('detail')"
                    >
                        {{ $t('취소') }}
                    </b-button>
                </template>
            </div>
            
        </div>

        <b-card no-body>
            
            <b-tabs class="default-tabs" :class="{'with-actions': mode !== 'add'}" content-class="mt-3">
                <b-tab v-model="tabIndex" :title="$t('기본 정보')">
                    <template v-if="loading">
                        <b-skeleton-img no-aspect class="empty-content"></b-skeleton-img>
                    </template>
                    <template v-else>
                        <CompanyDetail v-if="mode === 'detail'" :detail-data="detailData"/>
                        <CompanyForm v-else ref="companyForm" :mode="mode" :detail-data="detailData"
                                     @updateDetailData="updateDetailData"
                        />
                    </template>
                </b-tab>
                <b-tab v-if="mode === 'detail'" :title="$t('소속 유저')">
                    <template v-if="loading">
                        <b-skeleton-img no-aspect class="empty-content"></b-skeleton-img>
                    </template>
                    <template v-else>
                        <CompanyMembers :members="detailData.member"
                                        :company="detailData"
                                        @updateMember="updateMember"
                        />
                    </template>
                </b-tab>
                <b-tab v-if="mode === 'detail'" :title="$t('평가 참여 정보')">
                    <template v-if="loading">
                        <b-skeleton-img no-aspect class="empty-content"></b-skeleton-img>
                    </template>
                    <template v-else>
                        <AdminCompanyAssessmentInfo :selected_company="detailData"/>
                    </template>
                </b-tab>
                <b-tab v-if="mode === 'detail'" :title="$t('연결 프로젝트')">
                    <template v-if="loading">
                        <b-skeleton-img no-aspect class="empty-content"></b-skeleton-img>
                    </template>
                    <template v-else>
                        <ConnectedProject :selected_company="detailData"/>
                    </template>
                </b-tab>
            </b-tabs>
        </b-card>
    </b-container>
</template>

<script>
import CompanyDetail from '@shared/components/admin/pages/Management/Company/_SubComponent/CompanyDetail.vue';
import CompanyForm from '@shared/components/admin/pages/Management/Company/_SubComponent/CompanyForm.vue';
import CompanyMembers from '@shared/components/admin/pages/Management/Company/_SubComponent/CompanyMembers.vue';
import AdminCompanyAssessmentInfo
    from '@shared/components/admin/pages/Management/Company/_SubComponent/AssessmentInfo.vue';
import ConnectedProject from '@shared/components/admin/pages/Management/Company/_SubComponent/ConnectedProject.vue';

export default {
    name: 'CompanyManagementDetail',
    components: {
        ConnectedProject,
        AdminCompanyAssessmentInfo,
        CompanyMembers,
        CompanyForm,
        CompanyDetail,
    },
    data() {
        return {
            mode: 'detail',
            tabIndex: 1,
            detailData: {id: null},
            loading: false,
            isFromExternal: false,
        };
    },
    computed: {
        modalTitle() {
            if (this.mode === 'add') {
                return this.$t('기업 등록');
            } else if (this.mode === 'edit') {
                return this.$t('기업 수정');
            } else {
                return this.$t('기업 상세');
            }
        },
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            if (from.name === null) {
                vm.isFromExternal = true;
            }
        });
    },
    created() {
        this.fetchDetailData();
    },
    methods: {
        changeMode(mode) {
            this.mode = mode;
            this.tabIndex = 1;
        },
        goToList(){
            if (this.isFromExternal) {
                this.$router.replace('/admin/company');
            } else {
                this.$router.go(-1);
            }
        },
        async fetchDetailData() {
            try {
                this.loading = true;
                const company_id = this.$route.params.company_id;

                const _res_company_info = await this.$axios.get(`/admin/company/${company_id}/info`);
                const {company, member, projects} = _res_company_info.data;
                const {company_name, company_code, company_address, company_tel, client, country} = company;
                this.detailData = {
                    company_id: company_id, company_name, company_code, company_address, company_tel, client, country,
                    member: member.map((item,index) => ({...item, index})), projects
                };
            } catch (e) {
                console.error(e);
                console.dir(e);
            } finally {
                this.loading = false;
            }
        },
        updateMember(updatedUser){
            const userId = updatedUser.user_id || updatedUser.id;
            const idx = this.detailData.member.findIndex((item) => {
                return item.user_id === userId;
            });
            if(idx > -1){
                this.$set(this.detailData.member, idx, updatedUser);
            }
            else if(userId != null){
                this.detailData.member = this.detailData.member.concat([updatedUser]);
            }
        },
        async updateDetailData(detailData){
            this.detailData = {
                ...this.detailData,
                ...detailData,
            };
            if(this.mode === 'edit'){
                this.changeMode('detail');
            }
        }
    },
};
</script>

<style scoped lang="scss">

</style>
